//Paquetes NPM de GYF. 
import { Mediator } from 'com-gyf-webcore-mediator';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let _dispatch, _tarjetas, _userFunctions = null;
let _empresaId = undefined;
let userFeatures = [];

// ACTION TYPES
export const GUARDAR_EMPRESA_EMPRESA = 'GUARDAR_EMPRESA_EMPRESA';
export const INITIAL_STATE_EMPRESA = 'INITIAL_STATE_EMPRESA';
export const CHANGE_INPUT_EMPRESA = 'CHANGE_INPUT_EMPRESA';
export const GET_CLIENTE_DATA_EMPRESA = 'GET_CLIENTE_DATA_EMPRESA';
export const GET_CLIENTE_DATA_RESULT_EMPRESA = 'GET_CLIENTE_DATA_RESULT_EMPRESA';
export const SHOW_ALERT_EMPRESA = 'SHOW_ALERT_EMPRESA_EMPRESA';
export const SELECT_RUBRO_EMPRESA = 'SELECT_RUBRO_EMPRESA';
export const SELECT_COMBO_EMPRESA = 'SELECT_COMBO_EMPRESA';
export const GET_GEOGRAPHIC_CODE_EMPRESA = 'GET_GEOGRAPHIC_CODE_EMPRESA';
export const REMOVE_RUBRO_EMPRESA = 'REMOVE_RUBRO_EMPRESA';
export const ROUTE_TO_CANCEL_EMPRESA = 'ROUTE_TO_CANCEL_EMPRESA';
export const ROUTE_TO_EMPRESA_EMPRESA = 'ROUTE_TO_EMPRESA_EMPRESA';
export const GET_ROUTTING_STATE_EMPRESA = 'GET_ROUTTING_STATE_EMPRESA';
export const CHANGE_CHECK_EMPRESA = 'CHANGE_CHECK_EMPRESA';
export const CHANGE_CHECK_ES_CONFIDENCIAL_EMPRESA = 'CHANGE_CHECK_ES_CONFIDENCIAL_EMPRESA';
export const FUNCTION_CODE_CONFIDENTIAL_EMPRESA = 'Confidencial';
export const CHANGE_DATE_EMPRESA = 'CHANGE_DATE_EMPRESA';
export const CHANGE_RADIO_EMPRESA = 'CHANGE_RADIO_EMPRESA';
export const FILTRO_RUBROS_EMPRESA = 'FILTRO_RUBROS_EMPRESA';
export const ACTUALIZAR_ESTADO_GLOBAL_EMPRESA = 'ACTUALIZAR_ESTADO_GLOBAL_EMPRESA';
export const VALIDATE_EMPRESA_ERROR_EMPRESA = 'VALIDATE_EMPRESA_ERROR_EMPRESA';
export const CHANGE_CUENTA_PAY_METHOD = 'CHANGE_CUENTA_PAY_METHOD';
export const ELIMINAR_FUTURO_FROM_EMPRESA = 'ELIMINAR_FUTURO_FROM_EMPRESA';
export const ESTA_CARGANDO_EMPRESA = 'ESTA_CARGANDO_EMPRESA';
export const CHANGE_DATE_ERROR_PANEL = 'CHANGE_DATE_ERROR_PANEL';
export const EMPRESA_RESET_CHECK_SUBPRODUCTO = 'EMPRESA_RESET_CHECK_SUBPRODUCTO';
export const ACTUALIZAR_ESTADO_GLOBAL_CATEGORIA_IVA = 'ACTUALIZAR_ESTADO_GLOBAL_CATEGORIA_IVA';

export function changePayMethod(id, val) {
    return (dispatch) => {
        dispatch({ type: CHANGE_CUENTA_PAY_METHOD, value: val, id: id });
    }
}

/** 
 * Action que obtiene el estado inicial.
 * @param {any} state
 * @param {any} currentScope
 */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE_EMPRESA });
    }
}

/**
 * 
 */
export function changeDataError() {
    LogHelper.In(changeDataError.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({
            type: CHANGE_DATE_ERROR_PANEL
        });
    }
}

/** 
 * Action que obtiene el estado inicial.
 * @param {any} state
 * @param {any} currentScope
 */
export function getScreenData(state, currentScope) {
    LogHelper.In(getScreenData.name, state, currentScope);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        _empresaId = JSON.parse(state);

        _tarjetas = JSON.parse(JSON.stringify(getState().tarjetas));

        dispatch({ type: ESTA_CARGANDO_EMPRESA });
        dispatch({ type: GET_CLIENTE_DATA_EMPRESA });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadScreenData(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}


export function selectCombo(action, id) {
    LogHelper.In(selectCombo.name, action, id);

    return (dispatch) => {
        dispatch({ type: SELECT_COMBO_EMPRESA, action: action, id: id });
    }
}

export function resetChecksSubProducto(relacionId) {
    return (dispatch, getState) => {
        let checksSubProducto = {
            checkPermiteCuotas: getState().tarjetas.tipoEmpresa.PermiteCuotas,
            checkPermiteAdelantos: getState().tarjetas.subTipoCuenta.find(subtipo => subtipo.RelacionId == relacionId).PermiteAdelantos
        };

        dispatch({ type: EMPRESA_RESET_CHECK_SUBPRODUCTO, checksSubProducto });
    }
}

/** 
 *  TODO: documentar metodo
 */
export function showAlert() {
    LogHelper.In(showAlert.name);

    return (dispatch) => {
        dispatch({
            type: SHOW_ALERT_EMPRESA
        });
    }
}


/** 
 * Action que obtiene el codigo geográfico.
 * @param {any} id 
 */
export function getGeographicCode(id) {
    LogHelper.In(showAlert.name, id);

    return (dispatch) => {
        dispatch({
            type: GET_GEOGRAPHIC_CODE_EMPRESA,
            idZipCode: id
        });
    }
}

export function filtroRubro(typeInput, isCheck) {
    LogHelper.In(filtroRubro.name, typeInput, isCheck);

    return (dispatch) => {
        dispatch({ type: ESTA_CARGANDO_EMPRESA });
        dispatch({
            type: FILTRO_RUBROS_EMPRESA,
            typeInput: typeInput,
            isCheck: isCheck
        });
    }
}

export function selectRubro(typeFilter, term) {
    LogHelper.In(selectRubro.name, typeFilter, term);

    return (dispatch) => {
        dispatch({ type: ESTA_CARGANDO_EMPRESA });
        dispatch({
            type: SELECT_RUBRO_EMPRESA,
            typeFilter: typeFilter,
            term: term
        });
    }
}

export function removeRubro(id, typeInput) {
    LogHelper.In(removeRubro.name, id, typeInput);

    return (dispatch) => {
        dispatch({ type: ESTA_CARGANDO_EMPRESA });
        dispatch({
            type: REMOVE_RUBRO_EMPRESA,
            idRubro: id,
            typeInput: typeInput
        });
    }
}

/** 
 * Action que valida el nombre de la empresa que no sea el mismo que otro.
 * @param {any} data
 * @param {any} form
 */
export function validateAddEnterprise(data, form) {
    LogHelper.In(validateAddEnterprise.name, data, form);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        const state = getState();
        let dataEmpresa = data;

        _loadValidateAddEnterprise(dataEmpresa, form, state);
    }
}

function _loadValidateAddEnterprise(dataEmpresa, form, state) {
    LogHelper.In(_loadValidateAddEnterprise.name, dataEmpresa, form);

    let fechaMinima = new Date("2000-01-01");
    let fechaTopeAgro = null;

    if(dataEmpresa.FechaTopeAgro)
    {
        if(dataEmpresa.FechaTopeAgro.includes("-")) {
            let fechaTopeAgroSplitted = dataEmpresa.FechaTopeAgro.split(' ');
            let fechaPartes = fechaTopeAgroSplitted[0].split('-');
            let anio = parseInt(fechaPartes[0], 10);
            let mes = parseInt(fechaPartes[1], 10) - 1; 
            let dia = parseInt(fechaPartes[2], 10);
            
            fechaTopeAgro = new Date(anio, mes, dia);
        } else {
            fechaTopeAgro = new Date(dataEmpresa.FechaTopeAgro.split("/")[2], dataEmpresa.FechaTopeAgro.split("/")[1] - 1, dataEmpresa.FechaTopeAgro.split("/")[0]);
        }
    }

    let subTipoCuentaData = state.tarjetas.subTipoCuenta.find(s => s.RelacionId == dataEmpresa.SubProductoPrismaId);
    let validarGaf = Boolean(subTipoCuentaData) && subTipoCuentaData.EmpresaGaf;
    let validarGastosEmision = dataEmpresa.CheckExpenses;
    let validarFechaTope = Boolean(subTipoCuentaData) && subTipoCuentaData.RequiereFechaTope;
    let validarCantidadMaximaDias = Boolean(subTipoCuentaData) && subTipoCuentaData.RequiereCantidadMaximaDias;
    let valids = [];

    form.validateFields((error, value) => {
        if (error == null) {
            return;
        }

        let limitRegEx = new RegExp(/^[0-9.,]+$/);
        let vigenciaRegEx = new RegExp(/^[1-9]+$/);
        let bonificacionRegEx = new RegExp(/^([1-9]?\d|100)$/);
        let destinatarioRegEx = new RegExp(/^[áéíóúÁÉÍÓÚüÜñÑ0-9A-Za-z\s]+$/);
     
        if (dataEmpresa.edicion) {
            if (dataEmpresa.DescriptionEnterprise != "") {
                delete error.inputDescripcion;
            }
            if (destinatarioRegEx.test(dataEmpresa.ReportReceiver)) {
                delete error.receiver;
            }
            if (limitRegEx.test(dataEmpresa.LimitPurchase)) {
                delete error.inputPurchase;
            }
            if (bonificacionRegEx.test(dataEmpresa.BonificacionAlta)) {
                delete error.inputBonus;
            }
            if (vigenciaRegEx.test(dataEmpresa.VigenciaDesdeAlta)) {
                delete error.inputVigenciaAlta;
            }
            if (vigenciaRegEx.test(dataEmpresa.VigenciaDesdeLaRenovacion)) {
                delete error.inputVigenciaRenovacion;
            }
            if (dataEmpresa.GeographicCode != "" && dataEmpresa.GeographicCode != "Otro") {
                delete error.inputGeo;
            }
        }
        else {
            if (limitRegEx.test(dataEmpresa.LimitPurchase)) {
                delete error.inputPurchase;
            }

            if (bonificacionRegEx.test(dataEmpresa.BonificacionAlta)) {
                delete error.inputBonus;
            }

            if (vigenciaRegEx.test(dataEmpresa.VigenciaDesdeAlta)) {
                delete error.inputVigenciaAlta;
            }
            if (vigenciaRegEx.test(dataEmpresa.VigenciaDesdeLaRenovacion)) {
                delete error.inputVigenciaRenovacion;
            }

            if (dataEmpresa.GeographicCode != "" && dataEmpresa.GeographicCode != "Otro") {
                delete error.inputGeo;
            }
        }

        const emailError = validarEmail(dataEmpresa.EmailEmpresa);
                
        dataEmpresa.ERROR_EMPRESA.inputEmailEmpresa = emailError === null ? true : emailError;
        valids.push(emailError === null);

        dataEmpresa.ERROR_EMPRESA["descripcion"] = (error.inputDescripcion == undefined);
        valids.push(dataEmpresa.ERROR_EMPRESA["descripcion"]);

        dataEmpresa.ERROR_EMPRESA["receiver"] = (error.receiver == undefined);
        valids.push(dataEmpresa.ERROR_EMPRESA["receiver"]);
        dataEmpresa.ERROR_EMPRESA["inputPurchase"] = (error.inputPurchase == undefined);
        valids.push(dataEmpresa.ERROR_EMPRESA["inputPurchase"]);

        dataEmpresa.ERROR_EMPRESA["inputBonus"] = (error.inputBonus == undefined);
        valids.push(dataEmpresa.ERROR_EMPRESA["inputBonus"]);

        dataEmpresa.ERROR_EMPRESA["inputVigenciaAlta"] = (error.inputVigenciaAlta == undefined);
        valids.push(dataEmpresa.ERROR_EMPRESA["inputVigenciaAlta"]);

        dataEmpresa.ERROR_EMPRESA["inputVigenciaRenovacion"] = (error.inputVigenciaRenovacion == undefined);
        valids.push(dataEmpresa.ERROR_EMPRESA["inputVigenciaRenovacion"]);

        dataEmpresa.ERROR_EMPRESA["inputGeo"] = (error.inputGeo == undefined);
        valids.push(dataEmpresa.ERROR_EMPRESA["inputGeo"]);
    });

    let seleccionoBonificacionRenovacion = (dataEmpresa.BonificacionRenovacion != undefined);
    dataEmpresa.ERROR_EMPRESA["seleccionoBonificacionRenovacion"] = seleccionoBonificacionRenovacion;
    valids.push(seleccionoBonificacionRenovacion);

    let seleccionoCartera = (dataEmpresa.Cartera != "");
    dataEmpresa.ERROR_EMPRESA["seleccionoCartera"] = seleccionoCartera;
    valids.push(seleccionoCartera);

    let seleccionoSubProducto = (dataEmpresa.SubProductoPrismaId != 0);
    dataEmpresa.ERROR_EMPRESA["SubProductoPrismaId"] = seleccionoSubProducto;
    valids.push(seleccionoSubProducto);

    let seleccionoAfinidad = validarGaf ? (dataEmpresa.Afinidad != 0) : true;
    dataEmpresa.ERROR_EMPRESA["Afinidad"] = seleccionoAfinidad;
    valids.push(seleccionoAfinidad);

    let gastosEmisionRegEx = new RegExp(/^(9999(,00?)?|9998(,9\d?)?|999[0-7](,\d{1,2})?|[1-9]\d{0,3}(,\d{1,2})?|0?(,\d{1,2})?)$/);
    let seleccionoImporte = true
    if(validarGastosEmision)
    { 
        seleccionoImporte = Boolean(dataEmpresa.GastosEmisionResumen) && gastosEmisionRegEx.test(dataEmpresa.GastosEmisionResumen)
    }

    dataEmpresa.ERROR_EMPRESA["GastosEmisionResumen"] = seleccionoImporte
    valids.push(seleccionoImporte);

    let seleccionoFechaTope = validarFechaTope ? (dataEmpresa.FechaTopeAgro !== null) : true; 
    dataEmpresa.ERROR_EMPRESA["inputFechaTope"] = seleccionoFechaTope;
    valids.push(seleccionoFechaTope);

    let fechaValida = validarFechaTope && fechaTopeAgro ? (fechaTopeAgro > fechaMinima) : true;
    dataEmpresa.ERROR_EMPRESA["inputFechaTopeMin"] = fechaValida;
    valids.push(fechaValida);

    let IngresaCantidadMaximaDias = validarCantidadMaximaDias? (dataEmpresa.CantidadMaximaDias != "") : true;
    dataEmpresa.ERROR_EMPRESA["cantidadMaximaDias"] = IngresaCantidadMaximaDias
    valids.push(IngresaCantidadMaximaDias);

    let cantMaxDiasRegEx = new RegExp(/^[1-9]\d{0,2}$/);
    let indicaCantMaxDias = true

    if(validarCantidadMaximaDias)
    { 
        indicaCantMaxDias = Boolean(dataEmpresa.CantidadMaximaDias) && cantMaxDiasRegEx.test(dataEmpresa.CantidadMaximaDias)
    }
    dataEmpresa.ERROR_EMPRESA["cantidadMaximaDias"] = indicaCantMaxDias
    valids.push(indicaCantMaxDias);

    let seleccionoValidezDesdeElAlta = (dataEmpresa.VigenciaDesdeAlta != 0);
    dataEmpresa.ERROR_EMPRESA["inputVigenciaAlta"] = seleccionoValidezDesdeElAlta;
    valids.push(seleccionoValidezDesdeElAlta);

    let seleccionoValidezDesdeLaRenovacion = (dataEmpresa.VigenciaDesdeLaRenovacion != 0);
    dataEmpresa.ERROR_EMPRESA["inputVigenciaRenovacion"] = seleccionoValidezDesdeLaRenovacion;
    valids.push(seleccionoValidezDesdeLaRenovacion);

    let seleccionoTipoRubro = (dataEmpresa.RubroEnterprise != "");
    dataEmpresa.ERROR_EMPRESA["seleccionoTipoRubro"] = seleccionoTipoRubro;
    valids.push(seleccionoTipoRubro);

    let existeDomicilio = (dataEmpresa.GET_DOMICILIOS.Direccion.hasOwnProperty('Calle') && dataEmpresa.GET_DOMICILIOS.Direccion.hasOwnProperty('Numero'));
    dataEmpresa.ERROR_EMPRESA["existeDomicilio"] = existeDomicilio;
    valids.push(existeDomicilio);

    if (dataEmpresa.CheckUpdateValue) {
        let seleccionoFechaRenovacion = (dataEmpresa.DateExpiration != "Seleccione una fecha" && dataEmpresa.DateExpiration != "");
        dataEmpresa.ERROR_EMPRESA["seleccionoFechaRenovacion"] = seleccionoFechaRenovacion;
        valids.push(seleccionoFechaRenovacion);

    } else {
        dataEmpresa.ERROR_EMPRESA["seleccionoFechaRenovacion"] = true;
        valids.push(true);
    }

    if (dataEmpresa.RubroEnterprise != "firstRadio" || (dataEmpresa.RubroEnterprise == "firstRadio" && dataEmpresa.checked)) {
        if (seleccionoTipoRubro) {
            let seleccionoRubro;
            if (dataEmpresa.checked) {
                seleccionoRubro = (dataEmpresa.rubroExcept.length != 0);
            }
            else {
                seleccionoRubro = (dataEmpresa.rubroOnly.length != 0);
            }
            dataEmpresa.ERROR_EMPRESA["seleccionoRubro"] = seleccionoRubro;
            valids.push(seleccionoRubro);
        }
    }
    else {
        dataEmpresa.ERROR_EMPRESA["seleccionoRubro"] = true;
        valids.push(true);
    }

    let validate = true;

    for (let valid of valids) {
        if (!valid) {
            validate = false;
            break;
        }
    }

    if (validate) {
        let tipoEmpresaId = _tarjetas.tipoEmpresa.Id;
        let tipoEmpresaCodigo = _tarjetas.tipoEmpresa.Codigo;

        _dispatch({
            type: GUARDAR_EMPRESA_EMPRESA,
            tipoEmpresaId: tipoEmpresaId,
            tipoEmpresaCodigo: tipoEmpresaCodigo,
            novedadesEmpresas: _tarjetas.novedadesEmpresas,
            empresaAGuardar: dataEmpresa,
            empresas:JSON.parse(JSON.stringify(_tarjetas.empresas))
        });

        // Almaceno en el state global de tarjetas el array que contiene los datos de la Categoria del IVA,
        // para que en caso de perder este dato del objeto que tiene la data de la empresa, se vuelva a cargar la categoria del IVA correspondiente 

        _dispatch({ type: ACTUALIZAR_ESTADO_GLOBAL_CATEGORIA_IVA, empresaCategoriaIVA: dataEmpresa.categoriaIVA});


        //Elimino el futuro si hay cuentas o tarjetas nuevas para una empresa y se agrega una nueva.
        if (_tarjetas.cuentas != undefined || _tarjetas.tarjetas != undefined) {
            if (_tarjetas.cuentas.find(x => x.esNueva == true) != undefined || _tarjetas.tarjetas.find(x => x.esNueva == true) != undefined)
                _dispatch({ type: ELIMINAR_FUTURO_FROM_EMPRESA });
        }
    } else {
        _dispatch({ type: VALIDATE_EMPRESA_ERROR_EMPRESA });
    }
}

export function getScreenDataRoutting(state) {
    LogHelper.In(getScreenDataRoutting.name, state);

    return (dispatch) => {
        dispatch({
            type: GET_ROUTTING_STATE_EMPRESA,
            state: state
        });
    }
}

export function routeToNuevaEmpresa(tarjetas_empresas) {
    LogHelper.In(routeToNuevaEmpresa.name, tarjetas_empresas);

    return (dispatch) => {
        dispatch({
            type: ACTUALIZAR_ESTADO_GLOBAL_EMPRESA,
            empresas: tarjetas_empresas
        })

        dispatch({
            type: ROUTE_TO_EMPRESA_EMPRESA
        });
    }
}

export function routeToCancel() {
    LogHelper.In(routeToCancel.name);

    return (dispatch) => {
        dispatch({
            type: ROUTE_TO_CANCEL_EMPRESA
        });
    }
}

export function changeInput(action, value) {
    LogHelper.In(changeInput.name, action, value);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({
            type: CHANGE_INPUT_EMPRESA,
            action: action,
            value: value
        });
    }
}

export function changeCheck(nombreCheck, estadoCheck) {
    LogHelper.In(changeCheck.name, nombreCheck, estadoCheck);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({
            type: CHANGE_CHECK_EMPRESA,
            valueNombreCheck: nombreCheck,
            valueEstadoCheck: estadoCheck
        });
    }
}

export function changeRadio(action, value) {
    LogHelper.In(changeRadio.name, action, value);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({
            type: CHANGE_RADIO_EMPRESA,
            action: action,
            value: value
        });
    }
}

export function changeDate(action, value) {
    LogHelper.In(changeDate.name, action, value);



    value = value.split(" ")[0].split("-");
    value = value.reverse().join("/");

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({
            type: CHANGE_DATE_EMPRESA,
            action: action,
            value: value
        });
    }
}

export function changecheckEsConfidencial(estadoCheck) {
    LogHelper.In(changecheckEsConfidencial.name, estadoCheck);

    return (dispatch) => {
        _dispatch = dispatch;

        dispatch({
            type: CHANGE_CHECK_ES_CONFIDENCIAL_EMPRESA,
            valueEstadoCheck: estadoCheck
        });
    }
}

// ---------------------------------------------------- FUNCIONES AUXILIARES ---------------------------------------------------- //
function _loadNewGeographicCodeData(data) {
    LogHelper.In(_loadNewGeographicCodeData.name, data);

    state.data.CODIGO_GEOGRAFICO = JSON.parse(data.GET_CODIGO_GEOGRAFICO_VISA).Recordset0.Rows;
    _dispatch({ type: GET_CLIENTE_DATA_RESULT_EMPRESA, result: state.data });
}

function _loadScreenData(data) {
    LogHelper.In(_loadScreenData.name, data);

    userFeatures = JSON.parse(JSON.stringify(data));
    let funcionesDelUsuario = JSON.parse(JSON.stringify(data.ADMINEMPCUETAR));

    let param;
    let functionsAllowed = {};

    functionsAllowed.Confidencial = funcionesDelUsuario.some(f => {
        return f.Codigo_Funcion == FUNCTION_CODE_CONFIDENTIAL_EMPRESA
    });

    _userFunctions = functionsAllowed;

    param = { 'CUIT': parseInt(_tarjetas.clienteResultadoBusqueda.Cuit) }

    let IdClient = {
        'FILTRO_ID_CLIENTE': parseInt(_tarjetas.clienteResultadoBusqueda.Cuit)
    }

    let IdAdministrator = {
        'ADMINISTRADORA_ID': parseInt(_tarjetas.administradora.Id)
    }

    let parametrosCategoriaIva = {
        'CATEGORIA_IVA_ID': _tarjetas.clienteResultadoBusqueda.tipoIva //desmockeado
    };

    let paramCodGeog = {
        'CODIGO_POSTAL': _tarjetas.clienteResultadoBusqueda.Domicilios[0] ? _tarjetas.clienteResultadoBusqueda.Domicilios[0].Direccion.CodigoPostal:"0"
    }

    let paramIdEmpresa = {
        'ID_EMPRESA': _empresaId
    }

    LogHelper.Out(_loadScreenData.name, param, 'GET_CLIENTE_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(param, 'GET_CLIENTE_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    //LogHelper.Out(_loadScreenData.name, param, 'GET_EMPRESA_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    //Engine1Proxy.AddDataSourcesRequests(param, 'GET_EMPRESA_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    LogHelper.Out(_loadScreenData.name, IdAdministrator, 'GET_CARTERAS', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(IdAdministrator, 'GET_CARTERAS', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_loadScreenData.name, IdAdministrator, 'GET_TIPOS_EMPRESA_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(IdAdministrator, 'GET_TIPOS_EMPRESA_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_loadScreenData.name, null, 'GET_RUBRO_COMERCIAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_RUBRO_COMERCIAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_loadScreenData.name, null, 'GET_BONIFICACION_RENOVACION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_BONIFICACION_RENOVACION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_loadScreenData.name, paramCodGeog, 'GET_CODIGO_GEOGRAFICO_VISA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(paramCodGeog, 'GET_CODIGO_GEOGRAFICO_VISA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_loadScreenData.name, IdClient, 'GET_DOMICILIOS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(IdClient, 'GET_DOMICILIOS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    LogHelper.Out(_loadScreenData.name, parametrosCategoriaIva, 'GET_CATEGORIA_IVA_BY_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametrosCategoriaIva, 'GET_CATEGORIA_IVA_BY_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_loadScreenData.name, parametrosCategoriaIva, 'GET_EMAIL_EMPRESA_BY_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(paramIdEmpresa, 'GET_EMAIL_EMPRESA_BY_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    let tipoEmpresaId = {
        'TIPO_EMPRESA_ID': parseInt(_tarjetas.tipoEmpresa.Id)
    }
    
    LogHelper.Out(_loadScreenData.name, tipoEmpresaId, 'GET_PRECIO_BY_CUENTA_VISA_TIPO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(tipoEmpresaId, 'GET_PRECIO_BY_CUENTA_VISA_TIPO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.Execute(_loadNuevaEmpresaData, null, null, "SOLICITUD");
}

function _loadNuevaEmpresaData(data) {
    LogHelper.In(_loadNuevaEmpresaData.name, data);

    const emailResult = JSON.parse(data.GET_EMAIL_EMPRESA_BY_ID);

    let _errorEnWebService = false;
    let result = {
        'id': _empresaId,
        'equivalenciaAtlasCategoriaIvaCodigoVisa': JSON.parse(data.GET_CATEGORIA_IVA_BY_ID).Recordset0.Rows[0],
        'GET_CLIENTE': JSON.parse(data.GET_CLIENTE_CUIT).Recordset0.Rows,
        'GET_EMPRESA': _tarjetas.empresas,
        'GET_DOMICILIOS': JSON.parse(data.GET_DOMICILIOS).Recordset0.Rows,
        'GET_DOCUMENTO': undefined,
        'GET_CARTERAS': JSON.parse(data.GET_CARTERAS).Recordset0.Rows,
        'GET_TIPOS_EMPRESA': JSON.parse(data.GET_TIPOS_EMPRESA_ADMINISTRADORA).Recordset0.Rows,
        'GET_RUBROS': JSON.parse(data.GET_RUBRO_COMERCIAL).Recordset0.Rows,
        'GET_RUBROS_FILTER_ALL': JSON.parse(data.GET_RUBRO_COMERCIAL).Recordset0.Rows,
        'GET_RUBROS_FILTER_EXCEPT': JSON.parse(data.GET_RUBRO_COMERCIAL).Recordset0.Rows,
        'GET_RUBROS_FILTER_ONLY': JSON.parse(data.GET_RUBRO_COMERCIAL).Recordset0.Rows,
        'GET_BONIFICACION': JSON.parse(data.GET_BONIFICACION_RENOVACION).Recordset0.Rows,
        'GET_CODIGO_GEOGRAFICO': JSON.parse(data.GET_CODIGO_GEOGRAFICO_VISA).Recordset0.Rows,
        'GET_PRECIO_BY_CUENTA_VISA_TIPO': JSON.parse(data.GET_PRECIO_BY_CUENTA_VISA_TIPO).Recordset0.Rows,
        'CODIGO_GEOGRAFICO': [],
        'TYPES_RUBROS': [{ "name": "All", "descripcion": "Todos" }, { "name": "Except", "descripcion": "Todos, excepto" }, { "name": "Only", "descripcion": "Solamente" }],
        'TotalLimit': 0,
        'Administrator': "Visa",
        'EnterpriseType': _tarjetas.tipoEmpresa.Descripcion,
        'AllowPayments': _tarjetas.tipoEmpresa.aceptaPagos,
        'DescriptionEnterprise': "",
        'Domicilio': "",
        'GeographicCode': "",
        'ReportReceiver': "",
        'EmailEmpresa': (emailResult && emailResult.Recordset0 && emailResult.Recordset0.Rows && emailResult.Recordset0.Rows.length > 0) ? emailResult.Recordset0.Rows[0].Email : '',
        'PhoneEnterprise': "",
        'CheckHomeBanking': true,
        'LimitPurchase': "",
        'Cartera': "",
        'RubroEnterprise': "",
        'RubroEnterpriseList': [],
        'CheckAdvance': true,
        'CheckLimit': false,
        'CheckForeign': true,
        'CheckPermiteCuotas': _tarjetas.tipoEmpresa.PermiteCuotas,
        'CheckReport': false,
        'CheckExpenses': true,
        'CheckUpdateValue': false,
        'CheckUpdateValueLocal': true,
        'AlertMessage': false,
        'BonificacionAlta': "100",
        'BonificacionRenovacion': undefined,
        'CheckDateExpiration': false,
        'DateExpiration': "",
        'FechaTopeAgro': "",
        'GastosEmisionResumen': "",
        'SubProductoPrismaId': "0",
        'Afinidad': "0",
        'VigenciaDesdeAlta': "0",
        'VigenciaDesdeLaRenovacion': "0",
        'DateAgro': "",
        'showError': false,
        'rubro': [],
        'rubroExcept': [],
        'rubroOnly': [],
        'rubrosNodesExcept': [],
        'rubrosNodesOnly': [],
        'rdFirstCheck': false,
        'enabledExcept': false,
        'checked': false,
        'disabled': false,
        'dataFetched': false,
        'rdSecondCheck': false,
        'enabledOnly': false,
        'changeDiscard': false,
        'TablaPreciosVisaCodigo': JSON.parse(data.GET_PRECIO_BY_CUENTA_VISA_TIPO).Recordset0.Rows[0].Codigo, // Acá se sobre escribe el valor de TablaPreciosVisaCodigo para que se inicie siempre en la misma posición [0]
        'EmpresaVisaPrecio': JSON.parse(data.GET_PRECIO_BY_CUENTA_VISA_TIPO).Recordset0.Rows, // Acá se almacenan todos los codigos de precios obtenidos
        'empresaVisaPrecio':JSON.parse(data.GET_PRECIO_BY_CUENTA_VISA_TIPO).Recordset0.Rows[0], // Acá se inicializa con el primer elemento el objeto para su posterior guardado
        'checkEsConfidencial': false,
        'errorEnWebService': _errorEnWebService,
        'userFunctions': _userFunctions,
        'redirectToNuevaSolicitudEmpresa': false,
        'tarjetas_empresas': _tarjetas.empresas,
    }
    
    result.GET_BONIFICACION.sort(x => x.Id < x.Id);
    
    let titIns = [];
    result.GET_CLIENTE.forEach(function (row) {
        if (row.FisicaJuridica === "J") {
            titIns.push(row);
        }
    });

    result.GET_CLIENTE = titIns;

    //result.GET_EMPRESA = _tarjetas.empresa.limit;
    let empresas = JSON.parse(JSON.stringify(_tarjetas.empresas));
    let empresa = empresas.find(x => x.Id == _empresaId);
    result.edicion = (empresa != undefined);
    
    if (result.edicion) {
        if (empresa.Id == 0) {
            result = cargarInfoMemoria(result, empresa);
        }
        else {
            if (!empresa.editada) {
                empresa = result.GET_EMPRESA.find(x => x.Id == _empresaId);
                result = cargarInfoBD(result, empresa);
            } else {
                result = cargarInfoMemoria(result, empresa);
            }
        }
    }
    else {
        let idSelected = _tarjetas.tipoEmpresa.Id;
        let tipoEmpresa = result.GET_TIPOS_EMPRESA.find(x => x.Id == idSelected);
        result.VigenciaDesdeAlta = tipoEmpresa.VigenciaDesdeAlta;
        result.VigenciaDesdeLaRenovacion = tipoEmpresa.VigenciaDesdeLaRenovacion;
    }


    //Utiliza los Domicilios
    let objAddress = result.GET_DOMICILIOS[0];
    if (!_tarjetas.clienteResultadoBusqueda.Domicilios[0].Direccion.hasOwnProperty('Calle'))
    {
        _tarjetas.clienteResultadoBusqueda.Domicilios[0].Direccion = objAddress;
    }
    
    let idZipCode;
    if (_tarjetas && _tarjetas.clienteResultadoBusqueda.Domicilios != null) {
        _tarjetas.clienteResultadoBusqueda.Domicilios.forEach(function (row) {
           // if (row.Direccion.CodigoDomicilio == "01") {
                result.GET_DOMICILIOS = row;
          //  }
        });

        if (objAddress != undefined) {
            idZipCode = objAddress.CodigoPostal;
            result.CODIGO_GEOGRAFICO = result.GET_CODIGO_GEOGRAFICO.filter(x => x.CodigoPostal == idZipCode);
        }
    }
    else {
        result.GET_DOMICILIOS = {
            'Direccion': "Error al obtener el Domicilio de la empresa"
        }
    }

    //Utiliza el Documento
    result.GET_DOCUMENTO = {
        'nombreEmpresa': _tarjetas.clienteResultadoBusqueda.esPersonaFisica ?  _tarjetas.clienteResultadoBusqueda.NOMBRE + " " + _tarjetas.clienteResultadoBusqueda.APELLIDO : _tarjetas.clienteResultadoBusqueda.RAZON_SOCIAL,
        'categoriaIva': undefined
    }

    result.GET_DOCUMENTO.id = result.equivalenciaAtlasCategoriaIvaCodigoVisa.Id;/* MOCKEADO HASTA OBTENER CLIENTE WS*/
    result.GET_DOCUMENTO.codigo = result.equivalenciaAtlasCategoriaIvaCodigoVisa.Codigo;
    result.GET_DOCUMENTO.categoriaIva = result.equivalenciaAtlasCategoriaIvaCodigoVisa.Descripcion;

    if (_tarjetas.clienteResultadoBusqueda.Id > 0) {
        result.GET_DOCUMENTO.nombreEmpresa = _tarjetas.clienteResultadoBusqueda.esPersonaFisica ?  _tarjetas.clienteResultadoBusqueda.NOMBRE + " " + _tarjetas.clienteResultadoBusqueda.APELLIDO : _tarjetas.clienteResultadoBusqueda.RAZON_SOCIAL;
    } 
    
    //Realizo dispatch
    _dispatch({ type: GET_CLIENTE_DATA_RESULT_EMPRESA, result: result });
}

//Esto es para la parte de edicion.
function cargarInfoMemoria(result, empresa) {
    LogHelper.In(cargarInfoMemoria.name, result, empresa);

    let empresaVisaPrecioSeleccionada = result.EmpresaVisaPrecio.find(codigo => codigo.Codigo == empresa.TablaPreciosVisaCodigo);

    result.DescriptionEnterprise = empresa.Descripcion;
    result.Domicilio = empresa.domicilio;
    result.GeographicCode = empresa.codeGeographic;

    //TODO: La funcionalidad de código geográfico no esta habilitada porque no se sabe de donde llega el campo. Por el momento se iguala el Id de domicilio para obtener los datos y nada mas.
    if (result.GeographicCode != "") {
        //let objAddress = result.GET_DOMICILIOS.find(x => x.Id == result.Domicilio.id);
        let objAddress = result.GET_DOMICILIOS;
        let idZipCode;
        if (objAddress != undefined) {
            idZipCode = objAddress.CodigoPostal;
            result.CODIGO_GEOGRAFICO = result.GET_CODIGO_GEOGRAFICO.filter(x => x.CodigoPostal == idZipCode);
        }
    }

    result.ReportReceiver = empresa.report;
    result.PhoneEnterprise = empresa.phone;

    let ix = _tarjetas.novedadesEmpresas.findIndex(x => x.Id == empresa.id);
    if (ix != -1) {
        result.LimitPurchase = _tarjetas.novedadesEmpresas[ix].LimiteCompra;

    }
    else {
        result.LimitPurchase = empresa.LimiteCompra;
    }

    if (result.LimitPurchase != null) {
        var num = result.LimitPurchase.toString().replace(/\./g, '');
        if (!isNaN(num)) {
            num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
            num = num.split('').reverse().join('').replace(/^[\.]/, '');
            result.LimitPurchase = num;
        }
    }

    result.Cartera = empresa.cartera;
    result.RubroEnterprise = empresa.RubroEnterprise;
    result.enabledExcept = empresa.enabledExcept;
    result.checked = empresa.checked;
    result.rubro = empresa.rubro;

    cargarRubrosMemoria(result, empresa);

    result.BonificacionAlta = empresa.bonificacionAlta
    result.BonificacionRenovacion = empresa.bonificacionRenovacion;
    result.CheckAdvance = empresa.checkAdvance;
    result.CheckPermiteCuotas = empresa.checkPermiteCuotas;
    result.CheckLimit = empresa.checkLimit;
    result.CheckHomeBanking = empresa.checkHomeBanking;
    result.CheckForeign = empresa.checkForeign;
    result.CheckReport = empresa.checkReport;
    result.CheckExpenses = empresa.checkExpenses;
    result.DateExpiration = empresa.dateExpiration;

    let fechaTopeAgro = empresa.FechaTopeAgro;

    if(empresa.FechaTopeAgro != null && empresa.FechaTopeAgro.includes("-")) {
        fechaTopeAgro = fechaTopeAgro.split('T');
        if(fechaTopeAgro.length == 1) {
            fechaTopeAgro = fechaTopeAgro[0].split(' ');
        }
        fechaTopeAgro = fechaTopeAgro[0].split('-');
        fechaTopeAgro = fechaTopeAgro[2] + '/' + fechaTopeAgro[1] + '/' + fechaTopeAgro[0];
    }

    result.FechaTopeAgro = fechaTopeAgro;
    result.EmpresaVisaPrecio = empresa.EmpresaVisaPrecio;
    result.TablaPreciosVisaCodigo = empresa.TablaPreciosVisaCodigo;
    result.TablaPreciosVisaId = empresa.TablaPreciosVisaId;
    result.CheckUpdateValue = empresa.checkUpdateValue;
    result.checkEsConfidencial = empresa.checkEsConfidencial;
    result.VigenciaDesdeLaRenovacion = empresa.vigenciaDesdeLaRenovacion;
    result.VigenciaDesdeAlta = empresa.vigenciaDesdeAlta;
    result.empresaVisaPrecio = empresaVisaPrecioSeleccionada;
    result.SubProductoPrismaId = empresa.SubProductoPrismaId;
    result.CantidadMaximaDias = empresa.CantidadMaximaDias;
    result.GastosEmisionResumen = empresa.GastosEmisionResumen && empresa.GastosEmisionResumen.toString().replace(".",",");
    result.Afinidad = empresa.Afinidad;
    return result;
}

function cargarInfoBD(result, empresa) {
    LogHelper.In(cargarInfoBD.name, result, empresa);

    let empresaVisaPrecioSeleccionada = result.EmpresaVisaPrecio.find(codigo => codigo.Codigo == empresa.TablaPreciosVisaCodigo);
    
    result.DescriptionEnterprise = empresa.Descripcion;
    result.Domicilio = empresa.Domicilio;
    result.ReportReceiver = empresa.DestinatarioReportes;
    result.PhoneEnterprise = empresa.Telefono;

    let ix = _tarjetas.novedadesEmpresas.findIndex(x => x.Id == empresa.id);
    if (ix != -1) {
        result.LimitPurchase = _tarjetas.novedadesEmpresas[ix].LimiteCompra;

    }
    else {
        result.LimitPurchase = empresa.LimiteCompra;
    }

    if (result.LimitPurchase != null) {
        var num = result.LimitPurchase.toString().replace(/\./g, '');
        if (!isNaN(num)) {
            num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
            num = num.split('').reverse().join('').replace(/^[\.]/, '');
            result.LimitPurchase = num;
        }
    }

    result.Cartera = {
        id: empresa.CarteraId,
        codigo: empresa.CarteraCodigo
    }

    cargarRubrosDB(result, empresa);

    result.BonificacionAlta = empresa.PorcentajeBonificacionAlta;
    result.BonificacionRenovacion = empresa.PorcentajeBonificacionRenovacion;
    result.CheckAdvance = empresa.PermiteAdelantos;
    result.CheckLimit = empresa.TieneLimiteTransaccion;
    result.CheckHomeBanking = empresa.GeneraNuevaClave;
    result.CheckForeign = empresa.PermiteConsumosExterior;
    result.CheckReport = empresa.GeneraReporteCuentaCentral;
    result.CheckExpenses = empresa.TomaGastosModeloLiquidacion;
    result.CheckPermiteCuotas = empresa.PermiteCuotas;
    result.DateExpiration = empresa.FechaTopeRenovacion;

    let fechaTopeAgro = empresa.FechaTopeAgro;

    if(empresa.FechaTopeAgro != null && empresa.FechaTopeAgro.includes("-")) {
        fechaTopeAgro = fechaTopeAgro.split('T');
        if(fechaTopeAgro.length == 1) {
            fechaTopeAgro = fechaTopeAgro[0].split(' ');
        }
        fechaTopeAgro = fechaTopeAgro[0].split('-');
        fechaTopeAgro = fechaTopeAgro[2] + '/' + fechaTopeAgro[1] + '/' + fechaTopeAgro[0];
    }

    result.FechaTopeAgro = fechaTopeAgro;
    result.CantidadMaximaDias = empresa.CantidadMaximaDias;
    result.CheckUpdateValue = empresa.CobraValorRenovacion;
    result.TablaPreciosVisaCodigo = empresa.TablaPreciosVisaCodigo;
    result.TablaPreciosVisaId = empresa.TablaPreciosVisaId;
    result.empresaVisaPrecio = empresaVisaPrecioSeleccionada;
    result.checkEsConfidencial = empresa.EsConfidencial;
    result.GeographicCode = empresa.DomicilioCodigoGeografico;
    result.VigenciaDesdeLaRenovacion = empresa.VigenciaRenovacion;
    result.VigenciaDesdeAlta = empresa.VigenciaAlta;
    result.SubProductoPrismaId = empresa.SubProductoPrismaId;
    result.GastosEmisionResumen = empresa.GastosEmisionResumen && empresa.GastosEmisionResumen.toString().replace(".",",");
    result.Afinidad = empresa.Afinidad;
    
    return result;
}

function cargarRubrosDB(result, empresa) {
    LogHelper.In(cargarRubrosDB.name, result, empresa);

    let list = [];
    let newList = [];
    let eliminate;
    let filter;
    let i;

    result.RubroEnterprise = empresa.RubroIncluidoExcluido != "I" ? "firstRadio" : "secondRadio";
    result.enabledExcept = empresa.RubroIncluidoExcluido == "E" ? true : false;
    result.checked = empresa.RubroIncluidoExcluido == "E" ? true : false;

    result.rubroList = [];
    if (result.RubroEnterprise == "firstRadio") {
        if (result.checked) {
            filter = result.GET_RUBROS_FILTER_EXCEPT;
            agregarRubrosBD(result.rubroList, empresa, filter);
            result.rubroList.map(function (except) {
                eliminate = filter.find(x => x.Id == except.Id);
                if (eliminate != undefined) {
                    i = result.GET_RUBROS_FILTER_EXCEPT.findIndex(x => x.Id === eliminate.Id)
                    if (i >= 0) {
                        result.GET_RUBROS_FILTER_EXCEPT.splice(i, 1);
                    }
                }
            });
            result.rdFirstCheck = true;
            result.enabledExcept = true;
            if (result.rubroList.length > 0) {
                result.rubroList.map(function (obj) {
                    list.push({ Id: obj.Id, Descripcion: obj.Descripcion });
                })
                result.rubroExcept = list;
                result.enabledExcept = true;
                result.checked = true;
                result.disabled = true;
            }
        } else {
            result.GET_RUBROS_FILTER_EXCEPT = [];
            result.rdFirstCheck = true;
            result.enabledExcept = true;
        }
    } else {
        filter = result.GET_RUBROS_FILTER_ONLY;
        agregarRubrosBD(result.rubroList, empresa, filter);

        result.rubroList.map(function (except) {
            eliminate = filter.find(x => x.Id == except.Id);
            if (eliminate != undefined) {
                i = result.GET_RUBROS_FILTER_ONLY.findIndex(x => x.Id === eliminate.Id);
                if (i >= 0) {
                    result.GET_RUBROS_FILTER_ONLY.splice(i, 1);
                }
            }
        });

        result.rubroList.map(function (obj) {
            list.push({ Id: obj.Id, Descripcion: obj.Descripcion });
        })
        result.rubroOnly = list;
        result.rdSecondCheck = true;
        result.enabledOnly = true;
    }

    //result.RubroEnterpriseList = result.rubroList;
}

function cargarRubrosMemoria(result, empresa) {
    LogHelper.In(cargarRubrosMemoria.name, result, empresa);

    let list = [];
    let newList = [];
    let eliminate;
    let filter;
    let i;
    if (result.RubroEnterprise == "firstRadio") {

        if (result.checked) {
            filter = result.GET_RUBROS_FILTER_EXCEPT;
            empresa.rubroList.map(function (except) {
                eliminate = filter.find(x => x.Id == except.Id);
                if (eliminate != undefined) {
                    i = result.GET_RUBROS_FILTER_EXCEPT.findIndex(x => x.Id === eliminate.Id)
                    if (i >= 0) {
                        result.GET_RUBROS_FILTER_EXCEPT.splice(i, 1);
                    }
                }
            });
            result.rdFirstCheck = true;
            result.enabledExcept = true;
            if (empresa.rubroList.length > 0) {
                empresa.rubroList.map(function (obj) {
                    list.push({ Id: obj.Id, Descripcion: obj.Descripcion });
                })
                result.rubroExcept = list;
                result.enabledExcept = true;
                result.checked = true;
                result.disabled = true;
            }
        } else {
            result.GET_RUBROS_FILTER_EXCEPT = [];
            result.rdFirstCheck = true;
            result.enabledExcept = true;
        }
    } else {
        filter = result.GET_RUBROS_FILTER_ONLY;
        empresa.rubroList.map(function (except) {
            eliminate = filter.find(x => x.Id == except.Id);
            if (eliminate != undefined) {
                i = result.GET_RUBROS_FILTER_ONLY.findIndex(x => x.Id === eliminate.Id)
                if (i >= 0) {
                    result.GET_RUBROS_FILTER_ONLY.splice(i, 1);
                }
            }
        });

        empresa.rubroList.map(function (obj) {
            list.push({ Id: obj.Id, Descripcion: obj.Descripcion });
        })
        result.rubroOnly = list;
        result.rdSecondCheck = true;
        result.enabledOnly = true;
    }

    result.RubroEnterpriseList = empresa.rubroList;
}

function agregarRubrosBD(rubroList, empresa, filter) {
    LogHelper.In(agregarRubrosBD.name, rubroList, empresa, filter);

    agregarRubroBD(rubroList, filter.find(x => x.Id == empresa.Rubro1));
    agregarRubroBD(rubroList, filter.find(x => x.Id == empresa.Rubro2));
    agregarRubroBD(rubroList, filter.find(x => x.Id == empresa.Rubro3));
    agregarRubroBD(rubroList, filter.find(x => x.Id == empresa.Rubro4));
    agregarRubroBD(rubroList, filter.find(x => x.Id == empresa.Rubro5));
    agregarRubroBD(rubroList, filter.find(x => x.Id == empresa.Rubro6));
    agregarRubroBD(rubroList, filter.find(x => x.Id == empresa.Rubro7));
    agregarRubroBD(rubroList, filter.find(x => x.Id == empresa.Rubro8));
    agregarRubroBD(rubroList, filter.find(x => x.Id == empresa.Rubro9));
}

function agregarRubroBD(rubrolist, rubro) {
    LogHelper.In(agregarRubroBD.name, rubrolist, rubro);

    if (rubro != null) {
        rubrolist.push(rubro);
    }
}

export function validarEmail(email) {
    if (!email) {
        return 'Debe ingresar un correo electrónico.';
    }

    const emailRegEx = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    if (!emailRegEx.test(email)) {
        return 'El correo electrónico ingresado tiene un formato no válido.';
    }

    const parts = email.split('@');
    if (parts[0].length > 30) {
        return 'El “usuario” (antes del @) no puede superar los 30 caracteres.';
    }

    if (parts[1].length > 30) {
        return 'El “dominio” (después del @) no puede superar los 30 caracteres.';
    }

    return null;
}


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/Empresa/actions/Actions.js